import { createApi } from '@reduxjs/toolkit/query/react';
import axios from 'axios';
import axiosInstance from './axiosInstance';

// Define the axiosBaseQuery function
const axiosBaseQuery = () => async ({ url, method, data, params }) => {
  try {
    const response = await axiosInstance({
      url,
      method,
      data,
      params,
    });
    return { data: response.data };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return { error };
    }
    // Handle non-Axios errors or unknown errors
    return { error: new Error('An unknown error occurred') };
  }
};

// Create the API services using createApi
export const apiServices = createApi({
  baseQuery: axiosBaseQuery(),
  endpoints: () => ({}),
  reducerPath: 'apiService',
});

export default apiServices;
